export default {
  system: {
    zh: '系统',
    en: 'System',
  },
  os: {
    zh: '操作系统',
    en: 'Operating System',
  },
  uptime: {
    zh: '运行时长',
    en: 'Uptime',
  },
  arch: {
    zh: '架构',
    en: 'Arch',
  },
}
